import style from './style.module.scss';

const Filter = ({ allTags, selectedTags, handleSelectTag }) => (
    <div className={style.block}>
        <ul className={style.filter}>
            {allTags &&
                allTags.map((tag) => (
                    <li
                        key={tag.term_id}
                        className={selectedTags.includes(tag.term_id) ? style.tagActive : style.tagUnactive}
                        onClick={() => handleSelectTag(tag)}
                    >
                        {tag.name}
                    </li>
                ))}
        </ul>
    </div>
);

export default Filter;
